module.exports = __webpack_public_path__ + "img/last-tab.3eb48e7.webp";